import momentTz from 'moment-timezone';
import moment from 'moment';
import CONFIG from './../../../config';
import { isEmpty } from 'lodash';
import {
    getCurrentClinicTimeFormatFromSession,
    is12HourClinicTimeFormat,
    resolveClinicTimeFormat,
} from './ClinicTimeFormatUtils';

const TIMEZONE = CONFIG.TIMEZONE || 'US/Central';
const DISPLAY_DATE_TIME_FORMAT_24 = 'DD MMM YYYY - HH:mm:ss';
const DISPLAY_DATE_TIME_FORMAT_12 = 'DD MMM YYYY - hh:mm:ss A';
const DISPLAY_DATE_TIME_WITHOUT_SECONDS_FORMAT_24 = 'DD MMM YYYY - HH:mm';
const DISPLAY_DATE_TIME_WITHOUT_SECONDS_FORMAT_12 = 'DD MMM YYYY - hh:mm A';
const DISPLAY_FORMATS = [
    DISPLAY_DATE_TIME_FORMAT_24,
    DISPLAY_DATE_TIME_FORMAT_12,
    DISPLAY_DATE_TIME_WITHOUT_SECONDS_FORMAT_24,
    DISPLAY_DATE_TIME_WITHOUT_SECONDS_FORMAT_12,
];

const parseSortableDate = (value) => {
    if (moment.isMoment(value)) {
        return value.toDate();
    }

    const strictParsed = moment(value, DISPLAY_FORMATS, true);
    if (strictParsed.isValid()) {
        return strictParsed.toDate();
    }

    const fallbackParsed = moment(value);
    if (fallbackParsed.isValid()) {
        return fallbackParsed.toDate();
    }

    return new Date(0);
};

export default class DateTimeUtils {

    static now() {
        return momentTz().tz(TIMEZONE);
    }

    static parse(datetimeStr) {
        return momentTz(datetimeStr).tz(TIMEZONE);
    }

    static parseUTC(datetimeStr) {
        return momentTz(moment.utc(datetimeStr).local().format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', 'UTC').tz(TIMEZONE);
    }

    static getDisplayDateTimeFormat(timeFormat = null, withSeconds = true) {
        const resolvedTimeFormat = resolveClinicTimeFormat(
            timeFormat || getCurrentClinicTimeFormatFromSession(),
        );
        const use12HourFormat = is12HourClinicTimeFormat(resolvedTimeFormat);

        if (withSeconds) {
            return use12HourFormat ? DISPLAY_DATE_TIME_FORMAT_12 : DISPLAY_DATE_TIME_FORMAT_24;
        }

        return use12HourFormat
            ? DISPLAY_DATE_TIME_WITHOUT_SECONDS_FORMAT_12
            : DISPLAY_DATE_TIME_WITHOUT_SECONDS_FORMAT_24;
    }

    static formatDisplayDateTime(value, timeFormat = null, withSeconds = true) {
        if (isEmpty(value)) return '';
        const parsed = moment(value);
        if (!parsed.isValid()) return '';

        return parsed.local().format(DateTimeUtils.getDisplayDateTimeFormat(timeFormat, withSeconds));
    }

    static dateSortComparator(v1, v2) {
        if (isEmpty(v1) && isEmpty(v2)) {
            return 0; // Equal if both are empty
        }
        
        if (isEmpty(v1)) {
            return 1; // v2 comes first if v1 is empty
        }
        
        if (isEmpty(v2)) {
            return -1; // v1 comes first if v2 is empty
        }
        
        const date1 = parseSortableDate(v1);
        const date2 = parseSortableDate(v2);
        
        return date1.getTime() - date2.getTime();
    }
    
}
